import { inject, Pipe, PipeTransform } from '@angular/core';

import { ShellStore } from '@iw/shell';

const DEFAULT_MASK_LENGTH = 8;

@Pipe({
  name: 'maskBalance',
  standalone: true,
  pure: false,
})
export class MaskBalancePipe implements PipeTransform {
  readonly #store = inject(ShellStore);
  readonly hidden = this.#store.balanceHidden;

  transform(value: unknown, length: number = DEFAULT_MASK_LENGTH): string {
    if (value === null || value === undefined) return '';
    return this.hidden() ? '*'.repeat(Math.max(0, length)) : String(value);
  }
}
